import React, { Component } from 'react'
import {v4} from 'uuid';
import PropTypes from 'prop-types';

export default class CeiTable extends Component {
    getDivStyle = () => {
        return { 
            background: "#f4f4f4",
            padding: "10px",
            borderBottom: "1px #ccc dotted",
            textAlign: "left",
            width: "inherit",
            flexFlow: "row wrap"
        };
    };

    getTBody = (args) => {
        let tbody = [], curr = [];
        args.forEach((element, index) => {
            if((index % 4 === 0 && index !== 0))
            {
                tbody.push(<tr key={v4()}>{curr}</tr>);
                curr = [<td key={v4()}><p className="cei-reference ui-link" onClick={(e)=>{this.props.onClick(element)}}>{element}</p></td>]
            }else{
                curr.push(<td key={v4()}><p className="cei-reference ui-link" onClick={(e)=>{this.props.onClick(element)}}>{element}</p></td>)
            }

            if(index === args.length - 1)
                tbody.push(<tr key={v4()}>{curr}</tr>);
        });

        return tbody;
    }

    render() {
        return (
            <div style={this.getDivStyle()}>
                <table>
                    <tbody>
                        {this.getTBody(this.props.args)}
                    </tbody>
                </table>
            </div>
        )
    }

    static propTypes = {
        args: PropTypes.array.isRequired
    }
}
